import { Drawer, IconButton, List, MenuItem, Toolbar, Tooltip, Typography } from "@mui/material";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import HomeIcon from "@mui/icons-material/Home";
import BarChartIcon from "@mui/icons-material/BarChart";

import Profile from "../Profile/Profile";
import logo from "../../assets/Fluent_Pulse_Logo-01.svg";
import { useNavigate } from "react-router-dom";

export const DRAWER_WIDTH = 260;
export const DRAWER_COLLAPSED_WIDTH = 64;

const getVersionLabel = () => {
  const raw = (process.env.REACT_APP_VERSION || "").replace(/^v/i, "");
  return raw ? `v${raw}` : "local";
};

const SideNavigationBar = ({ data, isCollapsed, onToggle, tabs, activeTab, onTabChange }) => {
  const navigate = useNavigate();
  const width = isCollapsed ? DRAWER_COLLAPSED_WIDTH : DRAWER_WIDTH;
  const versionLabel = getVersionLabel();

  return (
    <Drawer
      sx={{
        width,
        flexShrink: 0,
        "& .MuiDrawer-paper": {
          background: "#2D2DB8",
          width,
          boxSizing: "border-box",
          display: "flex",
          flexDirection: "column",
          overflowX: "hidden",
          transition: "width 225ms cubic-bezier(0.4, 0, 0.6, 1)",
        },
      }}
      variant="permanent"
      anchor="left"
    >
      <Toolbar
        sx={{
          color: "white",
          justifyContent: isCollapsed ? "center" : "space-between",
          gap: isCollapsed ? 0 : 1,
          px: isCollapsed ? 0 : 2,
          minHeight: "64px !important",
        }}
      >
        {!isCollapsed && (
          <img
            src={logo}
            alt="logo"
            style={{ maxWidth: 150, minWidth: 0, flexShrink: 1 }}
          />
        )}
        <IconButton
          onClick={onToggle}
          size="small"
          sx={{ color: "white", flexShrink: 0, ml: isCollapsed ? 0 : "auto" }}
          aria-label={isCollapsed ? "expand sidebar" : "collapse sidebar"}
        >
          {isCollapsed ? <ChevronRightIcon /> : <ChevronLeftIcon />}
        </IconButton>
      </Toolbar>

      <List>
        <Tooltip title={isCollapsed ? "Home" : ""} placement="right">
          <a
            href={`${process.env.REACT_APP_REDIRECT_URI}`}
            style={{ textDecoration: "none" }}
            onClick={() => navigate()}
          >
            <MenuItem
              disableRipple
              disableGutters
              sx={{
                color: "white",
                backgroundColor: "#0D1137",
                minHeight: "60px",
                position: "relative",
                justifyContent: isCollapsed ? "center" : "flex-start",
                paddingLeft: isCollapsed ? 0 : "20px",
                paddingRight: isCollapsed ? 0 : "12px",
                whiteSpace: "normal",
                lineHeight: 1.2,
              }}
            >
              <span
                style={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  width: "5px",
                  height: "100%",
                  background: "#E83278",
                }}
              />
              <HomeIcon sx={{ mr: isCollapsed ? 0 : 1, fontSize: 20, flexShrink: 0 }} />
              {!isCollapsed && "Home"}
            </MenuItem>
          </a>
        </Tooltip>

        {tabs?.map((tab, index) => (
          <Tooltip key={index} title={isCollapsed ? tab.name : ""} placement="right">
            <MenuItem
              disableRipple
              disableGutters
              onClick={() => onTabChange?.(index)}
              sx={{
                color: "white",
                backgroundColor: activeTab === index ? "#0D1137" : "transparent",
                minHeight: "60px",
                position: "relative",
                justifyContent: isCollapsed ? "center" : "flex-start",
                paddingLeft: isCollapsed ? 0 : "20px",
                paddingRight: isCollapsed ? 0 : "12px",
                whiteSpace: "normal",
                lineHeight: 1.2,
                cursor: "pointer",
              }}
            >
              {activeTab === index && (
                <span
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "5px",
                    height: "100%",
                    background: "#E83278",
                  }}
                />
              )}
              <BarChartIcon sx={{ mr: isCollapsed ? 0 : 1, fontSize: 20, flexShrink: 0 }} />
              {!isCollapsed && tab.name}
            </MenuItem>
          </Tooltip>
        ))}
      </List>
      <div
        style={{
          marginTop: "auto",
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          paddingRight: 16,
        }}
      >
        <Profile data={data} />
        {!isCollapsed && (
          <Typography
            variant="caption"
            sx={{ color: "rgba(255, 255, 255, 0.7)" }}
            data-testid="app-version"
          >
            {versionLabel}
          </Typography>
        )}
      </div>
    </Drawer>
  );
};

export default SideNavigationBar;
